import { useEffect, useState } from "react";
import clientsApi from "../../api/client/client";
import trainingCategoryApi from "../../api/trainingCategory/trainingCategory";
import { ui } from "../../helpers/ui";

const InitClientsInMinusLogic = () => {
  const [clients, setClients] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);

  const loadClients = () => {
    clientsApi
      .findDebtors()
      .then((response) => {
        if (response.status === 200) {
          // Ukupan minus po klijentu (zbir negativnih brojaca) i sortiranje
          // od najveceg duga (najnegativniji zbir) na dole.
          const withTotal = (response.data as any[]).map((c) => ({
            ...c,
            totalMinus: (c.negativeCounters ?? []).reduce(
              (s: number, nc: any) => s + (nc.counter ?? 0),
              0
            ),
          }));
          withTotal.sort((a, b) => a.totalMinus - b.totalMinus);
          setClients(withTotal);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const loadCategories = () => {
    trainingCategoryApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setCategories(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  useEffect(() => {
    loadClients();
    loadCategories();
  }, []);

  return {
    clients,
    categories,
  };
};

export default InitClientsInMinusLogic;
